export default function DashboardPage() {
  return (
    <div className="max-w-7xl mx-auto">
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Dashboard</h2>
        <p className="text-gray-600 mb-6">
          Welcome to your dashboard. Here you can see an overview of your
          application.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div
              key={i}
              className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-4"
            >
              <h3 className="font-semibold text-gray-800 mb-2">Metric {i}</h3>
              <p className="text-2xl font-bold text-blue-600">{i * 123}</p>
              <p className="text-gray-600 text-sm">Total count</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
